<template lang="html">
  <div class="row col-xs no-margin no-padding tables-containter">
    <adminPortalAnalyticsTableCard
      class="mb4"
      :tableKey="'activeTeacher'"
      :title="'Most Active Teachers'"
      :analyticsMostActiveTeachers="analyticsMostActiveTeachers"
      :tooltip="active_teachers_tooltip"
    />
    <adminPortalAnalyticsTableCard
      class="mb4"
      :tableKey="'inactiveTeacher'"
      :title="'Inactive Teachers'"
      :analyticsInactiveTeachers="analyticsInactiveTeachers"
      :tooltip="inactive_teachers_tooltip"
    />
    <adminPortalAnalyticsTableCard
      class="mb4"
      :tableKey="'recentTopicsUsed'"
      :title="'Recent Topics Used'"
      :analyticsRecentTopicsUsed="analyticsRecentTopicsUsed"
      :tooltip="recent_topics_used_tooltip"
    />
    <adminPortalAnalyticsTableCard
      class="mb4"
      :tableKey="'topUniversePortfolios'"
      :title="'Top Universe Portfolios'"
      :analyticsTopUniversePortfolios="analyticsTopUniversePortfolios"
      :tooltip="top_universe_portfolios_tooltip"
    />
  </div>
</template>
<script>
  import adminPortalAnalyticsTableCard from './adminPortalAnalyticsTableCard.vue';
  export default {
    props: {
      analyticsMostActiveTeachers: {
        type: Array,
        default() {
          return [];
        },
      },
      analyticsInactiveTeachers: {
        type: Array,
        default() {
          return [];
        },
      },
      analyticsRecentTopicsUsed: {
        type: Array,
        default() {
          return [];
        },
      },
      analyticsTopUniversePortfolios: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        active_teachers_tooltip:
          'This is the list of teachers who created the most RoundTables between the dates selected.',
        inactive_teachers_tooltip:
          'This is the list of teachers who created no RoundTables between the dates selected.',
        recent_topics_used_tooltip:
          'This is the list of topics from the Parlay Universe that teachers used between the dates selected, including which teachers used these topics.',
        top_universe_portfolios_tooltip:
          'This is the list of teachers in the school/district with the most number of RoundTables in their portfolios.',
      };
    },
    components: {
      adminPortalAnalyticsTableCard,
    },
  };
</script>
<style lang="stylus" scoped>
  .tables-containter
    justify-content: flex-end
    text-align: end
    @media (max-width: 1199px)
      justify-content: center
      text-align: center
</style>



// WEBPACK FOOTER //
// adminPortalAnalyticsTables.vue?dde441aa